import { useEffect, useCallback } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useProjectStore } from 'Store/Project'
import { shallow } from 'zustand/shallow'
import { toast } from 'react-toastify'

const ViewModel = () => {
  const navigate = useNavigate()
  const { id: projectId } = useParams<{ id: string }>()
  const { data, loading, getData, updatePileHolePrebore } = useProjectStore(
    state => ({
      data: state.pileHoles,
      loading: state.loading,
      getData: state.getPileHoles,
      updatePileHolePrebore: state.updatePileHolePrebore,
    }),
    shallow
  )

  const refetch = useCallback(() => {
    if (!projectId) return Promise.resolve()
    return getData(parseInt(projectId)).then(({ success, data: errData }) => {
      if (!success) {
        toast.error(`Fetch data failed : ${errData}`)
      }
    })
  }, [projectId, getData])

  const onContinueDriving = (pileHoleId: number) => {
    navigate(`/project/${projectId}/pile-execution?pileHoleId=${pileHoleId}`)
  }

  useEffect(() => {
    refetch()
  }, [refetch])

  return {
    data,
    projectId,
    loading,
    refetch,
    onContinueDriving,
    updatePileHolePrebore,
  }
}

export default ViewModel
